// extracted by mini-css-extract-plugin
module.exports = {"feedHeading":"FeedSection_feedHeading__SjXsh","messageError":"FeedSection_messageError__K4iGF","notRespond":"FeedSection_notRespond__3SXyi"};